import React from 'react';
import './artist-stream-details.css';


const ArtistStreamDetails = ({artist,label,value,logo,performance,first}) => {
	
	
	return (
		<div className='artist-stream-details-container'>
			<div className='artist-stream-details-header'>
				<div className={`artist-stream-details-copy ${first ? 'first-label' : ''}`}>{label}</div>
				{logo && 
					<img className='artist-stream-details-social' src={logo} alt='' />
				}
			</div>
			<div className='artist-stream-details-value'>{value}</div>
			<div className='artist-stream-details-performance'>{performance}</div>
			
		</div>
	)
}

export default ArtistStreamDetails